<template>
    <div v-if="exibir">
        <template v-if="assinatura">
            <span v-html="assinatura"></span>
        </template>
        <template v-else>
            <div>
                <template v-if="exibir.pessoa && exibir.pessoa.cadastro">
                    {{ exibir.pessoa.cadastro.ch_sexo == 'M' ? 'Dr.' : 'Dra.' }}
                </template>
                <template v-else>
                    Dr(a).
                </template>
                <strong>{{ exibir.pessoa ? exibir.pessoa.st_nome : exibir.st_nome_exibicao }}</strong>
            </div>
            <div v-if="exibir.conselho">
                {{ exibir.conselho.st_sigla }}:
                <strong>{{ " " + exibir.in_numero_conselho }}{{ exibir.estado_conselho ? '-' + exibir.estado_conselho.st_sigla : '' }}</strong>
            </div>
            <div v-if="exibir.medico_especialidade && exibir.medico_especialidade.length">
                <strong>
                    {{ exibir.medico_especialidade[0].especialidade.st_especialidade }}
                </strong>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    props: ['medico'],

    computed: { 
        assinatura: function () { 
            if ( !this.exibir || !this.exibir.st_assinatura )
                return "";

            let breakTag = '<br>';
            return (this.exibir.st_assinatura + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
        },

        exibir: function () { 
            if ( ( !this.medico.medico_especialidade || !this.medico.conselho ) && this.$store.state.user.id_pessoa == this.medico.id_pessoa ) { 
                let medico = { 
                    ...this.$store.state.user.medico,
                    pessoa: { ...this.$store.state.user.pessoa }
                };

                return medico;
            }

            return this.medico;
        }
    }
}
</script>